<template>
  <div>
    <div class="columns">
      <div class="column has-text-centered">
        <div class="buttons is-centered">
          <button
            v-for="(sel, ind) in selection"
            :key="ind"
            class="button"
            v-bind:class="active(ind + 1)"
            @click="selData(ind)"
          >
            {{ sel.nombre }}
          </button>
        </div>
      </div>
    </div>
    <div class="columns">
      <dir
        class="column is-half is-offset-one-quarter inputregister inputencabezado"
      >
        <div class="field is-fullwidth has-addons">
          <div class="control">
            <a class="button" @click="f3">
              <span class="icon is-medium">
                <i class="material-icons">list_alt</i>
              </span>
            </a>
          </div>

          <div class="control is-expanded has-icons-left">
            <input
              id="inputEncabezado"
              v-model="inputEncabezado"
              @keydown="keyfunction($event)"
              class="input is-fullwidth is-primary"
              type="text"
              autocomplete="off"
            />
            <span v-show="editsel" class="icon is-small is-left">
              <i class="material-icons">edit</i>
            </span>
            <span v-show="!editsel" class="icon is-small is-left">
              <i class="material-icons">control_camera</i>
            </span>
          </div>
          <div class="control">
            <a class="button is-primary" @click="ok">
              <span class="icon">
                <i class="material-icons">done_outline</i>
              </span>
            </a>
          </div>
        </div>
      </dir>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      inputEncabezado: "",
      editsel: false,
    };
  },
  props: {
    selection: Array,
    columna: Number,
    fila: Number,
    encabezado: {
      type: Object,
    },
    comundata: {
      type: Object,
    },
  },
  computed: {
    ...mapState([
      "empresa",
      "resultDatamodal",
      "idtoken",
      "nits",
      "closenitModal",
      "productos",
      "bodegas",
      "vendedores",
    ]),
  },
  methods: {
    chargeData(f, c) {
      this.inputEncabezado = this.encabezado[this.selection[c + 1].cod];
    },
    ok() {
      if (this.columna < this.selection.length) {
        this.$emit("columna", this.columna + 1);
      } else {
        this.$emit("columna", 1);
        this.$emit("fila", this.fila + 1);
        setTimeout(function () {
          document.getElementById("inputReg").focus();
        }, 5);
        // TODO Aqui se debe poner que hacer cuando llegue al final de la fila en teoria sería que verifique nuevamente todo el encabezado de la factura y si todo esta bien que pase a ver los registros y si no que muestre el error
      }
    },
    f3() {
      const _this = this;
      const cod = this.selection[this.columna - 1].cod;
      if (cod === "nit") {
        const datanits = this.nits.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Tercero",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datanits,
          result: "inputEncabezado",
        });
      }
      if (cod === "nvendedor") {
        const datavendedor = this.vendedores.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Vendedor",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datavendedor,
          result: "inputEncabezado",
        });
      }
      if (cod === "nbodega") {
        const databodega = this.bodegas.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.descripcion,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la Bodega",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: databodega,
          result: "inputEncabezado",
        });
      }
      if (cod === "lprecios") {
        const keyslistadeprecios = Object.keys(
          this.empresa.modulos.pventa.listas
        );
        const datalistas = keyslistadeprecios.map((e) => {
          const d = {
            codigo: parseInt(e),
            nombre: _this.empresa.modulos.pventa.listas[e],
            id: e,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la Lista",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datalistas,
          result: "inputEncabezado",
        });
      }
      if (cod === "nccostos") {
        const dataccostos = this.comundata.ccostos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Centro de Costos",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: dataccostos,
          result: "inputEncabezado",
        });
      }
      if (cod === "fpago") {
        const datafpago = this.encabezado.vencimientos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la forma de pago",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datafpago,
          result: "inputEncabezado",
        });
      }
    },
    active(c) {
      if (c === this.columna) {
        return {
          "is-primary": true,
        };
      } else {
        return {
          // "is-light": true,
        };
      }
    },
    selData(c) {
      this.$emit("columna", c + 1);
      document.getElementById("inputEncabezado").focus();
    },
    keyfunction(e) {
      if (e.keyCode === 121) {
        // presiona la tecka f10
        e.preventDefault();
        this.$emit("f10guardar");
      }
      if (e.keyCode === 113) {
        // presiona la tecla f2
        e.preventDefault();
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (e.keyCode === 114) {
        // presiona la tecla f3
        e.preventDefault();
        this.f3();
      }
      if (e.keyCode === 39) {
        // presiona la tecla a la derecha

        if (!this.editsel) {
          e.preventDefault();
          if (this.columna < this.selection.length) {
            this.$emit("columna", this.columna + 1);
          }
        }
      }
      if (e.keyCode === 37) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.columna > 1) {
            this.$emit("columna", this.columna - 1);
          }
        }
      }
      if (e.keyCode === 40) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila === -1) {
            this.$emit("fila", this.fila + 1);
            if (this.columna > 4) {
              this.$emit("columna", 4);
            }
            setTimeout(function () {
              document.getElementById("inputReg").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 38) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila > 0) {
            this.$emit("fila", this.fila - 1);
            setTimeout(function () {
              document.getElementById("inputEncabezado").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 13 || e.keyCode === 9) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        this.ok();
      }
    },
  },
  created() {
    this.chargeData(this.fila, this.columna - 2);
  },
  watch: {
    resultDatamodal(newv, oldv) {
      if (newv.result === "inputEncabezado") {
        this.inputEncabezado = newv.data[newv.title[0].cod];
        document.getElementById("inputEncabezado").focus();
      }
    },
    inputEncabezado(newv, oldv) {
      this.$emit("changeInputEncabezado", {
        columna: this.columna,
        fila: this.fila,
        data: newv,
      });
    },
    columna(newv, oldv) {
      this.chargeData(this.fila, newv - 2);
      setTimeout(function () {
        document.getElementById("inputEncabezado").select();
      }, 5);
    },
  },
};
</script>

<style lang="scss" scoped>
.inputencabezado {
  padding: 1px;
  margin-top: 1px;
}
.column {
  padding: 2px 15px 2px 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/registrar/Formencabezado2.vue